export default __webpack_public_path__ + "static/media/workspace.88aab8e2.svg";